const INDIVIDUALIZED_SERVICES = new Set([
  'MEDICATION_ADMINISTRATION',
  'MEDICATION_ASSISTANCE',
  'MEDICATION_MANAGEMENT',
  'GROOMING_GUIDANCE',
  'ASSISTANCE_WITH_PETS',
  'MEAL_PLANNING',
  'NUTRITION_EDUCATION',
  'MOBILITY_TRAINING',
]);

const HEALTH_SERVICES = new Set([
  'WOUND_CARE',
  'PAIN_MANAGEMENT',
  'IV_THERAPY_INJECTIONS',
  'DIABETIC_CARE',
  'CENTRAL_LINE_CARE',
  'OSTOMY_CARE',
]);

const NON_MEDICAL_TRANSPORTATION = 'NON_MEDICAL_TRANSPORTATION';
const RUN_ERRANDS = 'RUN_ERRANDS';

const toUpper = (value: string): string => String(value).toUpperCase();

export interface CompanionCareOfferedServiceFormState {
  individualizedServices: string[];
  healthAndMedicalServices: string[];
  willingToProvideTransportation: boolean;
  willingToRunErrands: boolean;
}

export const offeredServicesFromProfile = (profile: Record<string, any> | null | undefined): string[] => {
  if (!profile) return [];

  if (Array.isArray(profile.services) && profile.services.length > 0) {
    return profile.services.map(toUpper);
  }

  const combined = [...(profile.individualizedServices || []), ...(profile.healthAndMedicalServices || [])].map(toUpper);

  if (profile.willingToProvideTransportation) combined.push(NON_MEDICAL_TRANSPORTATION);
  if (profile.willingToRunErrands) combined.push(RUN_ERRANDS);

  return combined;
};

export const offeredServicesToFormState = (services: string[]): CompanionCareOfferedServiceFormState => {
  const upper = services.map(toUpper);
  return {
    individualizedServices: upper.filter((value) => INDIVIDUALIZED_SERVICES.has(value)),
    healthAndMedicalServices: upper.filter((value) => HEALTH_SERVICES.has(value)),
    willingToProvideTransportation: upper.includes(NON_MEDICAL_TRANSPORTATION),
    willingToRunErrands: upper.includes(RUN_ERRANDS),
  };
};

export const formStateToOfferedServices = (state: CompanionCareOfferedServiceFormState): string[] => {
  const services = [...state.individualizedServices, ...state.healthAndMedicalServices].map(toUpper);
  if (state.willingToProvideTransportation) services.push(NON_MEDICAL_TRANSPORTATION);
  if (state.willingToRunErrands) services.push(RUN_ERRANDS);
  return [...new Set(services)];
};

export const isIndividualizedOfferedService = (value: string): boolean => INDIVIDUALIZED_SERVICES.has(toUpper(value));
export const isHealthOfferedService = (value: string): boolean => HEALTH_SERVICES.has(toUpper(value));
